import { render, staticRenderFns } from "./Tenants.vue?vue&type=template&id=7141128e&scoped=true&"
import script from "./Tenants.vue?vue&type=script&lang=js&"
export * from "./Tenants.vue?vue&type=script&lang=js&"
import style0 from "./Tenants.vue?vue&type=style&index=0&id=7141128e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7141128e",
  null
  
)

export default component.exports